var map = {
	"./10.jpg": 57,
	"./10.svg": 125,
	"./11.jpg": 59,
	"./12.png": 60,
	"./13.jpg": 61,
	"./14.png": 56,
	"./15.png": 126,
	"./9.jpg": 127,
	"./MaiQuyTrung_CV.pdf": 41,
	"./address_image.svg": 128,
	"./animated_logo.svg": 129,
	"./blogs_image.svg": 130,
	"./cloud_infrastructure.svg": 131,
	"./codeInLogo.png": 132,
	"./contactMail.png": 133,
	"./coursera_logo.png": 134,
	"./data_science.svg": 135,
	"./deeplearning_ai_logo.png": 136,
	"./delhivery_logo.png": 137,
	"./developerActivity.svg": 138,
	"./dsc_logo.png": 139,
	"./education.svg": 140,
	"./experience.svg": 141,
	"./feelingProud.svg": 142,
	"./freecopy_logo.png": 143,
	"./fullstack.svg": 144,
	"./gcp_logo.png": 145,
	"./github_logo.png": 146,
	"./googleAssistant.jpg": 147,
	"./googleAssistant.svg": 148,
	"./google_logo.png": 149,
	"./haskell.png": 150,
	"./ibm_logo.png": 151,
	"./idp.png": 152,
	"./iiitk_logo.png": 153,
	"./intel_logo.jpg": 154,
	"./iu_logo.png": 155,
	"./jsFramework.svg": 156,
	"./legato_logo.png": 157,
	"./manOnTable.svg": 158,
	"./microsoft_logo.png": 159,
	"./mozilla_logo.png": 160,
	"./muffito_logo.png": 161,
	"./nextuLogo.jpg": 162,
	"./nptel_logo.png": 163,
	"./programmer.svg": 164,
	"./projects_image.svg": 165,
	"./pwa.png": 166,
	"./saayaHealthLogo.png": 167,
	"./stanford_logo.png": 168,
	"./talksCardBack.svg": 169,
	"./talksCardBackAlt.svg": 170,
	"./tiktok_logo.png": 171,
	"./ui_ux_design.svg": 172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55;